import { ChangeDetectorRef, Component, ElementRef, OnInit } from '@angular/core';
import { Notification } from '../interfaces/notification.interface';
import { DateTime } from 'luxon';
import { trackById } from '@vex/utils/track-by';
import { VexDateFormatRelativePipe } from '@vex/pipes/vex-date-format-relative/vex-date-format-relative.pipe';
import { Router, RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { NgClass, NgFor } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { NotifyService } from '../../../../../shared/services/notify.service';
import { GlobalService } from '../../../../../shared/services/global.service';
import { AuthService } from '../../../../../shared/services/auth.service';
import { Helper } from '../../../../../shared/constants/helper';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';

@Component({
  selector: 'vex-toolbar-notifications-dropdown',
  templateUrl: './toolbar-notifications-dropdown.component.html',
  styleUrls: ['./toolbar-notifications-dropdown.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    NgFor,
    MatRippleModule,
    RouterLink,
    NgClass,
    VexDateFormatRelativePipe
  ],
  providers: [GlobalService, NotifyService, AuthService]
})
export class ToolbarNotificationsDropdownComponent implements OnInit {
  notifications: Notification[];
  notificationCount: number = 0;
  selectedData: any;
  originRef?: ElementRef;

  trackById = trackById;
  private dropdownOpen: boolean;

  constructor(private notifyService: NotifyService,
              private router: Router,
              private popover: VexPopoverService,
              private cd: ChangeDetectorRef,) {
  }

  ngOnInit() {
    this.refresh();
  }

  refresh(): void {
    this.get();
  }

  get(): void {
    // this.notifyService.unreadNotification().subscribe(data => {
    //   if(data && data['data'].length > 0) {
    //     this.notificationCount = data['data'].length;
    //     let notification: any = [];
    //     data['data'].forEach((value: any): void => {
    //       // @ts-ignore
    //       const differenceHours: number = Math.abs(new Date() - new Date(value.created_at)) / (1000 * 60 * 60);
    //       notification.push({
    //         id: value.id,
    //         label: value.notification,
    //         icon: 'mat:feedback',
    //         colorClass: 'text-primary-600',
    //         datetime: DateTime.local().minus({ hour: differenceHours }),
    //         read: false
    //       });
    //     });
    //     this.notifications = notification;
    //   }
    // });
  }

  readAllNotification(): void{
    if(this.notificationCount > 0){
      this.notifyService.readNotification().subscribe(data => {
        this.notificationCount = 0;
        this.notifications = [];
        this.goto('/notification/list');
      });
    }
  }

  goto(url: any): void {
    this.router.navigateByUrl(url);
  }
}
